import { IAction } from "../model/IAction";
import { IElement } from "../model/IProcessData";
import { IElementDictionary } from "../model/IProcessData";

export const PASTE_ELEMENTS = "PASTE_ELEMENTS";
export function pasteElements(copiedElements: CopiedElement[]): PasteElementAction {
    return {
        type: PASTE_ELEMENTS,
        pastedElements: copiedElements
    };
}

export interface CopiedElement {
    id: string;
    element: IElement;
}

export interface PasteElementAction extends IAction {
    pastedElements: CopiedElement[];
}
